import { rootApi } from "../../api/rootApi";

export const schemeApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    createScheme: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/scheme/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchAllScheme: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/scheme`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchSchemeById: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/scheme/${params.id}&limit=${params.limit}&offset=${params.offset}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    updateSchemeById: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/scheme/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchSchemeFilters: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/scheme/scheme-filters?scheme_id=${params.scheme_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),

    fetchSchemeStats: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/scheme/scheme-stats`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchSchemeProductsCodes: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/scheme/scheme-search-products-codes`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    deleteSchemeById: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/scheme/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    schemeUserSearch: builder.mutation({
      query: ({ body, slug, token }) => {
        return {
          method: "POST",
          url: `/tenant/scheme/user-data`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            slug: slug,
          },
          body: body,
        };
      },
    }),
    bulkUploadSchemeRewards: builder.mutation({
      query: (params) => {
        const formData = new FormData();
        formData.append("file", params.file);
        if (params.scheme_id) {
          formData.append("scheme_id", params.scheme_id);
        }
        return {
          method: "POST",
          url: `/tenant/scheme/bulk-upload`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: formData,
        };
      },
    }),
    validateSchemeProductCodes: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/scheme/validate-product-codes`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: { codes: params.codes },
      }),
    }),
    fetchSchemeSkuPoints: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/scheme/${params.id}/sku-points`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
    sendSchemeReminder: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/scheme/${params.id}/send-reminder`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: { kind: params.kind },
      }),
    }),
    bulkManualQrReward: builder.mutation({
      query: (params) => {
        const formData = new FormData();
        formData.append("file", params.file);
        if (params.scheme_id) {
          formData.append("scheme_id", params.scheme_id);
        }
        return {
          method: "POST",
          url: `/tenant/scheme/bulk-manual-qr-reward`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: formData,
        };
      },
    }),
  }),
});

export const {
  useCreateSchemeMutation,
  useFetchAllSchemeMutation,
  useFetchSchemeByIdMutation,
  useUpdateSchemeByIdMutation,
  useDeleteSchemeByIdMutation,
  useSchemeUserSearchMutation,
  useBulkUploadSchemeRewardsMutation,
  useBulkManualQrRewardMutation,
  useValidateSchemeProductCodesMutation,
  useFetchSchemeSkuPointsMutation,
  useSendSchemeReminderMutation,
  useFetchSchemeFiltersMutation,
  useFetchSchemeStatsMutation,
  useFetchSchemeProductsCodesMutation,
} = schemeApi;
